import React from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Button, Row, Col, Card } from "react-bootstrap";
import blogs from "../data/blog";

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogs.find((b) => b.id === parseInt(id));

  // Sidebar ke liye 5 blogs (current ko hata ke)
  const sidebarBlogs = blogs.filter((b) => b.id !== parseInt(id)).slice(0, 5);

  if (!blog) return <h2 className="text-center mt-5">Blog Not Found</h2>;

  return (
    <Container className="my-5">
      <Row>
        {/* LEFT SIDE - BLOG CONTENT */}
        <Col md={9}>
          <img
            src={blog.img}
            alt={blog.title}
            className="img-fluid rounded mb-4 w-100"
            style={{ maxHeight: "600px", objectFit: "cover" }}
          />

          <h1 className="fw-bold mb-3">{blog.title}</h1>
          <p className="text-muted">{blog.desc}</p>

          {/* TAGS */}
          <p className="badge bg-secondary">Date:{blog?.date}</p>
          <div className="mb-3">
            {blog.tags?.map((tag) => (
              <span
                key={tag}
                className="badge bg-secondary me-2"
                style={{ cursor: "pointer" }}
              >
                {/* #{tag} */}
              </span>
            ))}
          </div>

          <hr />

          <p
            style={{
              lineHeight: "1.8",
              fontSize: "18px",
              whiteSpace: "pre-line",
              textAlign: "justify",
            }}
          >
            {blog.content}
          </p>

          <Link to="/">
            <Button variant="dark" className="mt-4">
              ← Back to Blogs
            </Button>
          </Link>
        </Col>

        {/* RIGHT SIDE - SIDEBAR */}
        <Col md={3}>
          <h4 className="mb-4">Latest Blogs</h4>

          {sidebarBlogs.map((item) => (
            <Card key={item.id} className="mb-3 shadow-sm">
              <div style={{ height: "150px", overflow: "hidden" }}>
                <Card.Img
                  variant="top"
                  src={item.img}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <Card.Body>
                <Card.Title style={{ fontSize: "16px" }}>
                  {item.title}
                </Card.Title>

                <Link to={`/blog/${item.id}`}>
                  <Button size="sm" variant="dark">
                    Read More
                  </Button>
                </Link>
              </Card.Body>
            </Card>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default BlogDetails;
